import React from 'react';
import { connect } from 'react-redux';
import { openAffectationDialog } from 'store/common/commonActions';
import PropTypes from 'prop-types';
import ReclamationRow from './ReclamationRow';
import { ReclamationStatut } from 'constants.js';

class ReclamationRowContainer extends React.Component {

    handleClickAffectation = () => {
        const { reclamationId } = this.props;

        // On change le state de l'appli
        this.props.openAffectationDialog(reclamationId);
    };

    render() {
        const { reclamation, utilisateurCourantId } = this.props;

        const statutCloture = reclamation.statut === ReclamationStatut.ClotureClient || reclamation.statut === ReclamationStatut.ClotureDefinitive;

        // Onvérifie l'&appart
        let utilisateur = JSON.parse(localStorage.getItem('utilisateur'));
        let utilisateurGTEntrepot = false;

        if (utilisateur && utilisateur.groupes.find(x => x.code === 'QUALITE_ENTREPOT') !== undefined) {
            utilisateurGTEntrepot = true;
        }

        let autoriseAffectation = !statutCloture && reclamation.utilisateur !== undefined &&
            (reclamation.adminOuPilote === true || (reclamation.utilisateur === null || reclamation.utilisateur === undefined || reclamation.utilisateur.id === 0) || (reclamation.utilisateur.id === utilisateurCourantId));

        return (
            <ReclamationRow
                reclamation={reclamation}
                onClickAffectation={this.handleClickAffectation}
                autoriseAffectation={autoriseAffectation}
                utilisateurGTEntrepot={utilisateurGTEntrepot}
            />
        );
    }
}

ReclamationRowContainer.propTypes = {
    reclamationId: PropTypes.number.isRequired
};

const mapStateToProps = (state, props) => {

    let reclamation = state.reclamation.reclamations.items.find(x => x.id === props.reclamationId);
    let utilisateur = localStorage.getItem('utilisateur');

    return {
        reclamation: reclamation,
        changeCount: reclamation.changeCount !== undefined && reclamation.changeCount !== null ? reclamation.changeCount : 0,
        utilisateurCourantId: utilisateur ? JSON.parse(utilisateur).id : 0
    };
};

const mapDispatchToProps = dispatch => ({
    openAffectationDialog: (reclamationId) => dispatch(openAffectationDialog(reclamationId))
});

export default connect(mapStateToProps, mapDispatchToProps)(ReclamationRowContainer);
